<template>
  <section class="dp-layout">
    <section class="dp-right">
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <div class="tbl-scroll-host">
    <el-table :data="users" v-loading="listLoading" row-key="Id" border lazy :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" style="width: 100%" height="100%" ref="table"
      @select="dialogCheck" @row-click="selectCurrentRow" class="custom-tbl">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="80" :index="rowIndex"></el-table-column>
      <el-table-column label="菜单/按钮" min-width="220" class-name="perm-name-col">
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.Icon"></i>

          {{ scope.row.Name }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="PnameArr" label="父节点" width="">
      </el-table-column>-->
      <el-table-column prop="Code" label="路由地址" width></el-table-column>
      <el-table-column prop="MName" label="API接口" width></el-table-column>
      <el-table-column prop="OrderSort" label="Sort" width></el-table-column>
      <el-table-column prop="IsButton" label="是否按钮" width="100">
        <template slot-scope="scope">
          <el-tag :type="!scope.row.IsButton ? 'success' : 'danger'" disable-transitions>{{ !scope.row.IsButton ? "否" :
            "是" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Func" label="按钮事件" width></el-table-column>
      <el-table-column prop="IsHide" label="是否隐藏" width="100">
        <template slot-scope="scope">
          <el-tag :type="!scope.row.IsHide ? 'success' : 'danger'" disable-transitions>{{ !scope.row.IsHide ? "否" : "是"
            }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="IskeepAlive" label="keepAlive" width="100">
        <template slot-scope="scope">
          <el-tag :type="!scope.row.IskeepAlive ? 'success' : 'danger'" disable-transitions>{{ !scope.row.IskeepAlive ?
            "否" : "是" }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
      </el-table-column>-->
    </el-table>
    </div>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" width="640px"
      custom-class="permission-menu-dialog" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="菜单名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型">
          <el-radio-group @change="clkTypeEdit" v-model="editForm.MenuType">
            <el-radio label="目录"></el-radio>
            <el-radio label="页面"></el-radio>
            <el-radio label="按钮"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="路由地址" prop="Code">
          <el-tooltip placement="top">
            <div slot="content">
              如果是目录，请填‘-’字符
              <br />如果是按钮，请输入空格即可
              <br />如果是外链，请带上协议，比如 https://www.baidu.com
              <br />
            </div>
            <el-input v-model="editForm.Code" :disabled="editCodeDisabled" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="描述" prop="Description">
          <el-input v-model="editForm.Description" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!editForm.IsButton" label="Icon" prop="Icon">
          <menu-icon-picker v-model="editForm.Icon" />
        </el-form-item>
        <el-form-item label="状态" prop="Enabled">
          <el-select v-model="editForm.Enabled" placeholder="请选择状态">
            <el-option v-for="item in statusList" :key="item.value" :label="item.Name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序" prop="OrderSort">
          <el-input type="number" v-model="editForm.OrderSort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="IsButton" label="是否按钮" width>
          <el-switch v-model="editForm.IsButton"></el-switch>
        </el-form-item>
        <el-form-item label="按钮事件" prop="Func">
          <el-tooltip class="item" effect="dark" content="只写方法名即可，不用带括号，比如：handleEdit" placement="top-start">
            <el-input v-model="editForm.Func" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="IsHide" label="隐藏菜单" width>
          <el-switch v-model="editForm.IsHide"></el-switch>
        </el-form-item>
        <el-form-item prop="IskeepAlive" label="keepAlive" width>
          <el-switch v-model="editForm.IskeepAlive"></el-switch>
        </el-form-item>
        <el-form-item prop="PidArr" label="父级菜单" width>
          <el-cascader placeholder="请选择，支持搜索功能" style="width: 400px" v-model="editForm.PidArr" :options="options"
            filterable :key="isResouceShow" :props="$deptCascaderPropsAnyNode"
            v-if="!editLoading"></el-cascader>
          <el-cascader placeholder="加载中..." style="width: 400px" v-if="editLoading"></el-cascader>
        </el-form-item>
        <el-form-item prop="Mid" label="API接口" width>
          <el-select style="width: 100%" v-model="editForm.Mid" placeholder="请选择API">
            <el-option :key="0" :value="0" :label="'无需api'"></el-option>
            <el-option v-for="item in modules" :key="item.Id" :value="item.Id" :label="item.LinkUrl">
              <span style="float: left">{{ item.LinkUrl }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.Name
                }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" width="640px"
      custom-class="permission-menu-dialog" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="菜单名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="菜单类型">
          <el-radio-group @change="clkType" v-model="addForm.MenuType">
            <el-radio label="目录"></el-radio>
            <el-radio label="页面"></el-radio>
            <el-radio label="按钮"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="路由地址" prop="Code">
          <el-tooltip placement="top">
            <div slot="content">
              如果是目录，请填‘-’字符
              <br />如果是按钮，请输入空格即可
              <br />如果是外链，请带上协议，比如 https://www.baidu.com
              <br />
            </div>
            <el-input v-model="addForm.Code" :disabled="addCodeDisabled" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="描述" prop="Description">
          <el-input v-model="addForm.Description" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!addForm.IsButton" label="Icon" prop="Icon">
          <menu-icon-picker v-model="addForm.Icon" />
        </el-form-item>
        <el-form-item label="状态" prop="Enabled">
          <el-select v-model="addForm.Enabled" placeholder="请选择状态">
            <el-option v-for="item in statusList" :key="item.value" :label="item.Name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input v-model="addForm.OrderSort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="IsButton" label="是否按钮" width>
          <el-switch v-model="addForm.IsButton"></el-switch>
        </el-form-item>
        <el-form-item label="按钮事件" prop="Func">
          <el-input v-model="addForm.Func" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="IsHide" label="隐藏菜单" width>
          <el-switch v-model="addForm.IsHide"></el-switch>
        </el-form-item>
        <el-form-item prop="IskeepAlive" label="keepAlive" width>
          <el-switch v-model="addForm.IskeepAlive"></el-switch>
        </el-form-item>
        <el-form-item prop="PidArr" v-if="options && options.length > 0" label="父级菜单" width>
          <el-cascader placeholder="请选择，支持搜索功能" style="width: 400px" v-model="addForm.PidArr" :options="options"
            filterable :key="isResouceShow" :props="$deptCascaderPropsAnyNode"
            v-if="!editLoading"></el-cascader>
          <el-cascader placeholder="加载中..." style="width: 400px" v-if="editLoading"></el-cascader>
        </el-form-item>

        <el-form-item prop="Mid" label="API接口" width>
          <el-select style="width: 100%" v-model="addForm.Mid" placeholder="请选择API">
            <el-option :key="0" :value="0" :label="'无需api'"></el-option>
            <el-option v-for="item in modules" :key="item.Id" :value="item.Id" :label="item.LinkUrl">
              <span style="float: left">{{ item.LinkUrl }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.Name
                }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getPermissionTreeTable, removePermission, editPermission, addPermission, getPermissionTree, getModuleListPage } from '../../api/modules/system';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import MenuIconPicker from "../../components/MenuIconPicker";

export default {
  components: { Toolbar, MenuIconPicker },
  data() {
    return {
      syncoptions: [],
      buttonList: [],
      currentRow: null,
      options: [],
      filters: {
        Name: "",
      },
      users: [],
      modules: [], //接口api列表
      statusList: [
        { Name: "激活", value: true },
        { Name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        Code: [{ required: true, message: "请输入路由地址", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Mid: 0,
        OrderSort: 0,
        PidArr: [],
        CreateBy: "",
        Name: "",
        Code: "",
        Description: "",
        Icon: "",
        Func: "",
        Enabled: true,
        IsButton: false,
        IsHide: false,
        IskeepAlive: false,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addCodeDisabled: false,
      editCodeDisabled: false,
      syncFormVisible: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        Code: [{ required: true, message: "请输入路由地址", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        Mid: 0,
        MenuType: "页面",
        OrderSort: 0,
        Name: "",
        Code: "",
        Description: "",
        Icon: "",
        Func: "",
        Enabled: true,
        IsButton: false,
        IsHide: false,
        IskeepAlive: false,
      },
      isResouceShow: 0,
    };
  },
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    clkType() {
      this.addForm.IsButton = false;
      this.addCodeDisabled = false;
      if (this.addForm.MenuType == "页面") {
        this.addForm.Code = "";
      } else if (this.addForm.MenuType == "目录") {
        this.addForm.Code = "-";
        this.addCodeDisabled = true;
      } else if (this.addForm.MenuType == "按钮") {
        this.addForm.Code = " ";
        this.addForm.IsButton = true;
        this.addCodeDisabled = true;
        // 根据名称自动填充Func
        const name = (this.addForm.Name || '').trim();
        if (name.includes('查询')) {
          this.addForm.Func = 'handleQuery';
        } else if (name.includes('新增')) {
          this.addForm.Func = 'handleAdd';
        } else if (name.includes('编辑')) {
          this.addForm.Func = 'handleEdit';
        } else if (name.includes('删除')) {
          this.addForm.Func = 'handleDel';
        } else {
          this.addForm.Func = '';
        }
      }
    },
    clkTypeEdit() {
      this.editForm.IsButton = false;
      this.editCodeDisabled = false;
      if (this.editForm.MenuType == "页面") {
        this.editForm.Code = "";
      } else if (this.editForm.MenuType == "目录") {
        this.editForm.Code = "-";
        this.editCodeDisabled = true;
      } else if (this.editForm.MenuType == "按钮") {
        this.editForm.Code = " ";
        this.editForm.IsButton = true;
        this.editCodeDisabled = true;
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      if (item.Func === "handleQuery") {
        this.page = 1;
      }
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    /**
     * 序号跨页连续：(当前页-1)*每页条数 + 行号
     */
    rowIndex(index) {
      return (this.page - 1) * this.pageSize + index + 1;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleQuery();
    },
    load(tree, treeNode, resolve) {
      // 展开只按父级取直接子节点，不带搜索关键字。关键字会让接口把命中行（含自身）再当作子级，row-key 成环。
      const parentId = tree && tree.Id;
      getPermissionTreeTable({ f: parentId }).then((res) => {
        const rows = this.sanitizeTreeRows(this.parseTreeTableRows(res), parentId);
        // 已在当前表里的 Id 不能再作为子节点，否则懒加载和根行共用 row-key，渲染会递归爆栈
        resolve(this.omitShownRows(rows));
      }).catch(() => resolve([]));
    },
    /**
     * 解析 GetTreeTable 响应（兼容 PageModel 与旧版数组）
     */
    parseTreeTableRows(res) {
      const response = res && res.data && res.data.response;
      if (!response) return [];
      if (Array.isArray(response)) return response;
      return response.data || [];
    },
    /**
     * 去掉实体上的空 Children，并按 Id 去重。父节点不能出现在自己的子级里。
     * 最后更新：2026-10-07
     */
    sanitizeTreeRows(rows, parentId) {
      const seen = new Set();
      if (parentId !== undefined && parentId !== null && parentId !== "") {
        seen.add(String(parentId));
      }
      const list = [];
      (rows || []).forEach((row) => {
        if (!row || typeof row !== "object") return;
        const copy = { ...row };
        delete copy.children;
        delete copy.Children;
        const id = copy.Id;
        if (id === undefined || id === null || id === "") {
          list.push(copy);
          return;
        }
        const key = String(id);
        if (seen.has(key)) return;
        seen.add(key);
        list.push(copy);
      });
      return list;
    },
    /**
     * 换一批根数据前清掉懒加载缓存。旧的展开结果若包含自身，再次渲染会栈溢出。
     * 最后更新：2026-10-07
     */
    clearLazyTree() {
      const states = this.$refs.table && this.$refs.table.store && this.$refs.table.store.states;
      if (!states) return;
      states.lazyTreeNodeMap = {};
      states.treeData = {};
    },
    /**
     * 去掉已经显示在根列表中的行，保证懒加载子节点的 row-key 不与现有行重复。
     * 最后更新：2026-10-07
     */
    omitShownRows(rows) {
      const shown = new Set();
      (this.users || []).forEach((row) => {
        if (row && row.Id !== undefined && row.Id !== null && row.Id !== "") {
          shown.add(String(row.Id));
        }
      });
      return (rows || []).filter((row) => {
        if (!row || row.Id === undefined || row.Id === null || row.Id === "") return true;
        return !shown.has(String(row.Id));
      });
    },
    //获取菜单列表（根节点分页，子节点按需展开）
    handleQuery() {
      let para = {
        f: 0,
        page: this.page,
        pageSize: this.pageSize,
        key: this.filters.name,
      };
      this.listLoading = true;

      getPermissionTreeTable(para).then((res) => {
        const pageData = res.data.response;
        this.clearLazyTree();
        if (pageData && !Array.isArray(pageData)) {
          this.users = this.sanitizeTreeRows(pageData.data || []);
          this.total = pageData.dataCount || 0;
          // 删除末页最后一条后当前页为空，回退到最后一页
          const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
          if (this.users.length === 0 && this.page > maxPage) {
            this.page = maxPage;
            this.handleQuery();
            return;
          }
        } else {
          this.users = this.sanitizeTreeRows(pageData || []);
          this.total = this.users.length;
        }
        this.currentRow = null;
        this.listLoading = false;
      }).catch(() => {
        this.users = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removePermission(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let that = this;

      that.options = [];

      this.editForm = {};
      that.editLoading = true;
      that.editFormVisible = true;
      that.editCodeDisabled = false;
      let para = { pid: row.Id };
      getPermissionTree(para).then((res) => {
        ++that.isResouceShow;
        this.options.push(res.data.response);
        that.editForm = Object.assign({}, row);
        that.editLoading = false;
      });
    },
    //显示新增界面
    handleAdd() {
      this.options = [];
      this.addFormVisible = true;
      this.addCodeDisabled = false;
      this.addLoading = true;
      this.addForm = {
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        Mid: 0,
        MenuType: "页面",
        Name: "",
        Code: "",
        OrderSort: 0,
        Description: "",
        Enabled: true,
        Icon: "",
        Func: "",
        IsButton: false,
        IsHide: false,
        IskeepAlive: false,
      };

      let para = { pid: 0 };
      getPermissionTree(para).then((res) => {
        ++this.isResouceShow;
        this.options.push(res.data.response);
        this.addLoading = false;
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");

            para.Pid = para.PidArr.pop();

            if (para.Id == para.Pid) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error",
              });

              this.editLoading = false;
              return;
            }

            editPermission(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              this.editLoading = false;
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.$refs.table.setCurrentRow();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            para.Pid = para.PidArr.pop();

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addPermission(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.handleQuery();

    getModuleListPage({ page: -1 }).then((res) => {
      this.modules = res.data.response.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 菜单树层级：按 Element 行层级类缩进 + 竖向导轨，全局已隐藏 el-table__indent。最后更新：2026-10-07 */
.custom-tbl /deep/ .perm-name-col .cell {
  position: relative;
  text-align: left;
  font-weight: 600;
  color: #0f172a;
}

.custom-tbl /deep/ tr[class*="el-table__row--level-"]:not(.el-table__row--level-0) .perm-name-col .cell {
  font-weight: 400;
  color: #475569;
}

.custom-tbl /deep/ tr[class*="el-table__row--level-"]:not(.el-table__row--level-0) .perm-name-col .cell::before {
  content: "";
  position: absolute;
  top: -12px;
  bottom: -12px;
  border-left: 1px dashed #cbd5e1;
}

.custom-tbl /deep/ .el-table__row--level-1 .perm-name-col .cell {
  padding-left: 36px;
}

.custom-tbl /deep/ .el-table__row--level-1 .perm-name-col .cell::before {
  left: 20px;
}

.custom-tbl /deep/ .el-table__row--level-2 .perm-name-col .cell {
  padding-left: 60px;
}

.custom-tbl /deep/ .el-table__row--level-2 .perm-name-col .cell::before {
  left: 44px;
}

.custom-tbl /deep/ .el-table__row--level-3 .perm-name-col .cell {
  padding-left: 84px;
}

.custom-tbl /deep/ .el-table__row--level-3 .perm-name-col .cell::before {
  left: 68px;
}
</style>

<style>
.permission-menu-dialog .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
}
</style>
